export class ShoppingCartItem {
	id: number;
	description: string;
	price: {value: number, currency: string}
}



// WEBPACK FOOTER //
// ./src/app/models/shopping-cart-item.model.ts